import { styled, Stack, Grid } from '@mui/material';
import { StyledGridProps } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

const Header = styled(Stack)(({ theme }) => ({
  width: '100%',
  alignItems: 'center',
  background: NEW_COLORS.BASE.WHITE,
  padding: '18px 60px',
  boxSizing: 'border-box',

  span: {
    fontSize: '14px',
    whiteSpace: 'nowrap',

    strong: {
      color: NEW_COLORS.PRIMARY[500],
      marginLeft: '10px',
    },
  },
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    '.MuiGrid-root': {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
}));

const StyledGrid = styled(Grid)<StyledGridProps>(({ hasClick }) => ({
  cursor: hasClick ? 'pointer' : 'default',
}));
export { Header, StyledGrid };
